import { z } from 'zod/v4';

export const errorResponseSchema = z.object({
  message: z.string(),
  error_id: z.string(),
  stack_trace: z.array(z.string()).optional(),
  error_message: z.string().optional(),
  error_class: z.string().optional(),
});

export type ErrorResponse = z.infer<typeof errorResponseSchema>;
